import { VisionMap } from './map';

export class VisionMapGeofence {
    map: VisionMap;
    id!: string;
    bounds!: google.maps.LatLngBounds;
    polygon!: google.maps.Polygon;
    name!: string;
    infoWindow!: google.maps.InfoWindow;

    constructor(map: VisionMap) {
        this.map = map;
    }

    createGeofence(points: google.maps.LatLng[], fillColour: string, _opacity: number) {
        const options = { map: null, fillColor: fillColour, strokeColor: fillColour };
        this.polygon = new google.maps.Polygon(options);
        this.polygon.setPath(points);
        /*
        this.polygon.addListener('click', (e:any)=> {
            if ( this.infoWindow == undefined ) {
                this.infoWindow = new google.maps.InfoWindow;
            }
            this.infoWindow.setContent(this.name);
            this.infoWindow.setPosition(e.latLng);
            this.infoWindow.open(this.map.map);
        })
        */

        this.bounds = new google.maps.LatLngBounds();
        points.forEach((latlng) => {
            this.bounds.extend(latlng);
        });
    }

    setColour(colour: string) {
        this.polygon.setOptions({ fillColor: colour, strokeColor: colour });
    }

    show() {
        this.polygon.setMap(this.map.map);
    }
    hide() {
        this.polygon.setMap(null);
    }
}
